import CompanySwapPlanDialog from './company-swap-plan-dialog.container';

export default CompanySwapPlanDialog;
